$(document).ready(function () {  


  $(".LN000013 .multi_coll > .colitem > .sub-list").each(function(){
    var _h =  $(".gnb_col3 .multi_coll").height();
    $(this).css({ "min-height" : "auto" });
    $(this).css({ "min-height" : _h });
  }); 

  $(".LN000013 .gnb_hover > li > a ").hover(function(){ 
    var _h =  $(".gnb_col3 .multi_coll").height();
    $(".sub-list", this).css({ "min-height" : "auto" });
    $(".sub-list", this).css({ "min-height" : _h });
  });



  // dep1 hover 
  $(".menu-list > li").hover(function($e){
    var _hoverIndex =  $(this).index();    
    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(".multi_coll > .colitem").eq(_hoverIndex).addClass("dep1_hover");
  }, function(){    
    //$(".multi_coll > .colitem").delay(10).removeClass("dep1_hover");
  })
  
    // dep2 hover
  $(".menu_dep1 .multi_coll > .colitem").hover(function($e){
    var _hoverIndex =  $(this).index();
    $(".menu_dep1  .menu-list > li").eq(_hoverIndex).addClass("hover");

    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(this).addClass("hover");
  }, function(){
    $(".menu_dep1  .menu-list > li").removeClass("hover");
    $(this).removeClass("hover");
  });

  // dep3 hover
  $(".menu_dep1 .menu_dep3").hover( function(){
    $(this).closest("li").addClass("on");
  }, function(){
    $(this).closest("li").removeClass("on");
  })


  // sticky 
  if( $(".sticky-wrap .labelscroll-area").length ){
    $('.labelscroll-area .mCustomScrollbar_x').mCustomScrollbar({autoHideScrollbar: true, axis:'x',advanced:{autoExpandHorizontalScroll:true}});
  }

})//ready

